import { render, staticRenderFns } from "./dianbofang.vue?vue&type=template&id=2c11b0f7&scoped=true"
import script from "./dianbofang.vue?vue&type=script&lang=js"
export * from "./dianbofang.vue?vue&type=script&lang=js"
import style0 from "./dianbofang.vue?vue&type=style&index=0&id=2c11b0f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11b0f7",
  null
  
)

export default component.exports